(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ryd-home-black-friday-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ryd-home-bf-slideshow')) return;

    const parseIso = value => {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:Z|([+-])(\d{2}):(\d{2}))$/.exec(value || '');
      if (!match) return NaN;
      const [, year, month, day, hour, minute, second, , offsetHour, offsetMinute] = match;
      const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
      if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() !== Number(month) - 1 || date.getUTCDate() !== Number(day)) return NaN;
      if (Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59 || Number(offsetHour || 0) > 14 || Number(offsetMinute || 0) > 59) return NaN;
      const stamp = Date.parse(value);
      return Number.isFinite(stamp) ? stamp : NaN;
    };

    class RydHomeBfSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-rydbf-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.mobileStorySets = [...this.querySelectorAll('[data-mobile-story-set]')];
        this.storyCtaLabels = [...this.querySelectorAll('[data-story-cta-label]')];
        this.controls = this.querySelector('[data-rydbf-controls]');
        this.status = this.querySelector('[data-slide-status]');
        this.clock = this.querySelector('[data-rydbf-clock]');
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.userPaused = this.dataset.autoplay !== 'true';
        this.manualPause = false;
        this.resumeTimer = null;
        this.pointerStart = null;
        this.reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || false;
        this.visual = this.querySelector('.rydbf-visual');

        this.onDot = event => {
          const dot = event.target.closest?.('[data-dot]');
          if (dot && this.contains(dot)) this.show(Number(dot.dataset.dot), true);
        };
        this.onVisibility = () => this.syncRotation();
        this.onBlockSelect = event => {
          const id = event.detail?.blockId || event.target?.dataset?.shopifyEditorBlock;
          const position = this.slides.findIndex(slide => slide.dataset.blockId === id);
          if (position >= 0) this.show(position, true);
        };
        this.onMotionChange = event => { this.reducedMotion = event.matches; this.syncRotation(); };
        this.onKeyDown = event => {
          if (event.target.matches?.('input,textarea,select')) return;
          if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1, true); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1, true); }
        };
        this.onTouchStart = event => {
          if (event.pointerType !== 'touch' || !event.isPrimary) return;
          this.pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
          try { this.visual?.setPointerCapture(event.pointerId); } catch (_) {}
        };
        this.onTouchEnd = event => {
          if (event.pointerType !== 'touch' || !this.pointerStart || event.pointerId !== this.pointerStart.id) return;
          const deltaX = event.clientX - this.pointerStart.x;
          const deltaY = event.clientY - this.pointerStart.y;
          this.pointerStart = null;
          if (Math.abs(deltaX) >= 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
            this.show(this.index + (deltaX < 0 ? 1 : -1), true);
          }
        };
        this.onTouchCancel = () => { this.pointerStart = null; };

        this.dots.forEach(dot => dot.addEventListener('click', this.onDot));
        this.addEventListener('keydown', this.onKeyDown);
        this.visual?.addEventListener('pointerdown', this.onTouchStart);
        this.visual?.addEventListener('pointerup', this.onTouchEnd);
        this.visual?.addEventListener('pointercancel', this.onTouchCancel);
        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.motionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
        this.motionQuery?.addEventListener?.('change', this.onMotionChange);

        if (this.controls && this.slides.length > 1) this.controls.hidden = false;
        this.show(this.index, false);
        this.updatePhase();
        this.phaseTimer = window.setInterval(() => this.updatePhase(), 1000);
        this.syncRotation();
      }

      disconnectedCallback() {
        this.stopRotation();
        window.clearTimeout(this.resumeTimer);
        window.clearInterval(this.phaseTimer);
        this.dots?.forEach(dot => dot.removeEventListener('click', this.onDot));
        this.removeEventListener('keydown', this.onKeyDown);
        this.visual?.removeEventListener('pointerdown', this.onTouchStart);
        this.visual?.removeEventListener('pointerup', this.onTouchEnd);
        this.visual?.removeEventListener('pointercancel', this.onTouchCancel);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.motionQuery?.removeEventListener?.('change', this.onMotionChange);
      }

      show(position, manual) {
        if (!this.slides?.length) return;
        this.index = (position + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const current = index === this.index;
          slide.classList.toggle('is-active', current);
          slide.inert = !current;
          slide.setAttribute('aria-hidden', String(!current));
        });
        this.dots?.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        const activeBlockId = this.slides[this.index]?.dataset.blockId;
        this.mobileStorySets?.forEach(set => {
          const current = set.dataset.blockId === activeBlockId;
          set.hidden = !current;
          set.inert = !current;
        });
        if (manual) {
          if (this.status) this.status.textContent = `Image ${this.index + 1} of ${this.slides.length}`;
          this.pauseAfterInteraction();
        }
        this.dataset.currentSlide = String(this.index);
      }

      pauseAfterInteraction() {
        window.clearTimeout(this.resumeTimer);
        this.manualPause = true;
        this.stopRotation();
        this.resumeTimer = window.setTimeout(() => {
          this.manualPause = false;
          this.syncRotation();
        }, 5000);
      }

      stateFor(now) {
        const design = this.dataset.designMode === 'true';
        const preview = this.dataset.previewState;
        if (design && ['preheat', 'active', 'ended'].includes(preview)) return preview;
        const showFrom = parseIso(this.dataset.showFrom);
        const start = parseIso(this.dataset.saleStarts);
        const end = parseIso(this.dataset.saleEnds);
        if (![showFrom, start, end].every(Number.isFinite) || start <= showFrom || end <= start) return 'ended';
        if (now < showFrom) return design ? 'preheat' : 'before';
        if (now < start) return 'preheat';
        if (now < end) return 'active';
        return 'ended';
      }

      updatePhase() {
        const state = this.stateFor(Date.now());
        this.dataset.state = state;
        const start = parseIso(this.dataset.saleStarts);
        const countdownTarget = start;
        const remaining = Math.max(0, Math.ceil((countdownTarget - Date.now()) / 1000));
        const clockVisible = state === 'preheat' && Number.isFinite(remaining) && remaining > 0;
        if (this.clock) {
          this.clock.hidden = !clockVisible;
          const units = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
          ['days', 'hours', 'minutes', 'seconds'].forEach((unit, index) => {
            const node = this.clock.querySelector(`[data-unit="${unit}"]`);
            if (node) node.textContent = String(units[index]).padStart(2, '0');
          });
        }
        const offerAvailable = this.dataset.currency === this.dataset.offerCurrency;
        const ctaText = state === 'active' && offerAvailable ? this.dataset.activeCta : this.dataset.preheatCta;
        this.storyCtaLabels?.forEach(label => { label.textContent = ctaText || ''; });
        if (state === 'before' && this.dataset.designMode !== 'true') this.querySelectorAll('.rydbf-cta').forEach(link => link.setAttribute('tabindex', '-1'));
        else this.querySelectorAll('.rydbf-cta').forEach(link => link.removeAttribute('tabindex'));
      }

      stopRotation() { window.clearInterval(this.rotationTimer); this.rotationTimer = null; }

      syncRotation() {
        this.stopRotation();
        const delay = Math.max(4000, Math.min(10000, Number(this.dataset.interval) || 6000));
        if (this.dataset.autoplay === 'true' && !this.userPaused && !this.manualPause && !this.reducedMotion && !document.hidden && this.isConnected && this.slides.length > 1) {
          this.rotationTimer = window.setInterval(() => this.show(this.index + 1, false), delay);
        }
      }
    }

    customElements.define('ryd-home-bf-slideshow', RydHomeBfSlideshow);
  })();

  } catch(e) { console.error(e); }
})();
})();
